import axios from "axios";
import * as actionType from "../../constant/actionType";

export const UpdateWorkerProfileSetting = (data) => async (dispatch) => {
  try {
    const formdata = new FormData();

    for (let key in data) {
      // Handle null or undefined values
      if (data[key] !== null && data[key] !== undefined) {
        formdata.append(key, data[key]);
      } else {
        formdata.append(key, ""); // Or skip appending if your API doesn't need it
      }
    }

    const response = await axios({
      method: "put",
      url: `${actionType.environment_url}/api/admin/worker/UpdateWorkerProfileSetting`,
      data: formdata,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("UpdateWorkerProfileSetting Error:", error);
    throw error;
  }
};
